import React, {useMemo} from 'react';
import TextComponent from './TextComponent';
import HTMLComponent from './HTMLComponent';
import YoutubeVideoComponent from './YoutubeVideoComponent';
import YoutubePlaylistComponent from './YoutubePlaylistComponent';
import CreativesGrid from '../../creatives/CreativesGrid';
import FileUploadMarketingPage from '../../fileupload/FileUploadMarketingPage';
import ProductLinksSection from '../../marketing-tools/ProductLinksSection';
import TeamExplorer from '../../mlm/TeamExplorer';
import IFrameComponent from './IFrameComponent';
import ViewAndAddLeads from '../../form-referrals/ViewAndAddLeads';
import LeadCaptureFormComponent
    from '../../form-referrals/LeadCaptureFormComponent';
import {useSelector} from 'react-redux';
import CopyButton from '../../../cmp/CopyButton';
import ConnectedCustomers from './ConnectedCustomers';
import LazyStoreIndex from '../../inportalstore/LazyStoreIndex';

const componentsList = {
    text: TextComponent,
    html: HTMLComponent,
    yt_video: YoutubeVideoComponent,
    yt_playlist: YoutubePlaylistComponent,
    creatives: CreativesGrid,
    iframe: IFrameComponent,
    form: LeadCaptureFormComponent,
    formPage: ViewAndAddLeads,
    formPageEmbedCode: FormPageEmbedCode,
    files:FileUploadMarketingPage,
    product_links: ProductLinksSection,
    teamExplorer: TeamExplorer,
    connectedCustomers: ConnectedCustomers,
    shop: LazyStoreIndex
};

const reducer = (state)=>[state.settings.ref_code, state.settings.partner_portal_subdomain];
function FormPageEmbedCode({formId}){
    const [ref_code, partner_portal_subdomain] = useSelector(reducer)
    const embedCode = useMemo(()=>{
        if(partner_portal_subdomain && ref_code) {
            const iframeUrl = new URL(
                `https://${partner_portal_subdomain}/public-form/${formId}`)
            iframeUrl.searchParams.append('ref_code', ref_code)
            return `<iframe src="${iframeUrl.href}" style="border:0px; width:100%" id="gfp_embed"></iframe><script type="text/javascript" defer src="https://static.goaffpro.com/embed.js"></script>`
        }else{
            return '';
        }
    },[ref_code, partner_portal_subdomain])
    return <>
        <textarea className={"form-control rounded"} readOnly onFocus={(e)=>e.target.select()} value={embedCode}/>
        <CopyButton text={embedCode} />
    </>
}

export default componentsList;
